import {
  CLEAR_PREREGISTROS_ACTION,
  FETCH_PREREGISTRO_INFO,
  FETCH_PREREGISTROS,
} from './actions.type';

import {
  SET_ERROR,
  FETCHING_PREREGISTROS,
  SET_PREREGISTROS,
  FETCHED_PREREGISTROS,
  CLEAR_PREREGISTROS,
  CLEAR_PREREGISTRO_INFO,
  SET_PREREGISTRO,
  STARTED_PREREGISTRO_PROCESSING,
  RESET_PREREGISTRO_PROCESSING,
  SUBMITED_PREREGISTRO,
  SUBMIT_PREREGISTRO_ERROR,
  RESET_PREREGISTRO_SUBMIT,
  CLEAR_ALERT_DIALOG,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_preregistros: false,
  processing_preregistro: false,
  submited_preregistro: false,
  preregistro_list: [],
  preregistro_info: {},
  preregistro_total: 0,
};

const getters = {
  is_loading() {
    return state.loading_preregistros;
  },
  preregistro_total(state) {
    return state.preregistro_total;
  },
  preregistro_list() {
    return state.preregistro_list;
  },
  preregistro_info() {
    return state.preregistro_info;
  },
  preregistro_submited() {
    return state.submited_preregistro;
  },
  preregistro_processing() {
    return state.processing_preregistro;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
};

const actions = {
  [FETCH_PREREGISTROS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_PREREGISTROS);
      ApiService.post('accesos/historic_walkins_list', data)
        .then(({ data }) => {
          context.commit(SET_PREREGISTROS, data);
          context.commit(FETCHED_PREREGISTROS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_PREREGISTROS);
        });
    });
  },
  [FETCH_PREREGISTRO_INFO](context, id) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_PREREGISTROS);
      context.commit(CLEAR_PREREGISTRO_INFO);
      ApiService.query(`accesos/walkins/${id}`)
        .then(({ data }) => {
          context.commit(SET_PREREGISTRO, data);
          context.commit(FETCHED_PREREGISTROS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_PREREGISTROS);
        });
    });
  },
  [CLEAR_PREREGISTROS_ACTION](context) {
    context.commit(CLEAR_PREREGISTROS);
  },
};

const mutations = {
  [FETCHING_PREREGISTROS](state) {
    state.loading_preregistros = true;
  },
  [SET_PREREGISTROS](state, data) {
    state.preregistro_list = data.walkins;
    state.preregistro_total = data.total;
  },
  [SET_PREREGISTRO](state, data) {
    state.preregistro_info = data.walkin;
  },
  [FETCHED_PREREGISTROS](state) {
    state.loading_preregistros = false;
  },
  [CLEAR_PREREGISTROS](state) {
    state.preregistro_list = [];
  },
  [CLEAR_PREREGISTRO_INFO](state) {
    state.preregistro_info = {};
  },
  [STARTED_PREREGISTRO_PROCESSING](state) {
    state.processing_preregistro = true;
  },
  [RESET_PREREGISTRO_PROCESSING](state) {
    state.processing_preregistro = false;
  },
  [SUBMITED_PREREGISTRO](state, data) {
    state.submited_preregistro = true;
    state.alert = true;
    state.alertType = 'success';
    state.alertMessage = data.message;
  },
  [SUBMIT_PREREGISTRO_ERROR](state, data) {
    state.submited_preregistro = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_PREREGISTRO_SUBMIT](state) {
    state.submited_preregistro = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
